import Mock from "mockjs"

import data from "./chartmockdata.json"

Mock.mock(/\/api\/charts\/queryProductAnalysisData/, "post", function(options){
    console.log(options)
    console.log(data.productAnalysisData)
    return Mock.mock(data.productAnalysisData)
})

Mock.mock(/\/api\/charts\/querySalesAnalysisData/, "post", function(options){
    console.log(options)
    console.log(data.salesAnalysisData)
    return Mock.mock(data.salesAnalysisData)
})

Mock.mock(/\/api\/charts\/querySalesmanAnalysisData/, "post", function(options){
    console.log(options)
    console.log(data.salesmanAnalysisData)
    return Mock.mock(data.salesmanAnalysisData)
})